
/* injects from baggage-loader */
require('./style.styl');

import React, {Component} from 'react'
import Button from 'components/Button'
import * as _ from 'lodash'
import {connect} from 'react-redux'
import {
  getOnboardStatus,
  confirmStep,
  initState
} from 'redux/modules/onboard/actions'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import PropTypes from 'prop-types'

class OnboardingWizard extends Component {
  static propTypes = {
    isInited: PropTypes.bool,
    isOnboardSuccess: PropTypes.bool,
    isLoadedStep: PropTypes.bool,
    steps: PropTypes.array,
    currentStep: PropTypes.string,
    getOnboardStatus: PropTypes.func,
    confirmStep: PropTypes.func,
    initState: PropTypes.func
  }

  componentDidMount() {
    const {isInited, isOnboardSuccess} = this.props

    if (!isInited) {
      this.props.initState()
    }

    if (!isOnboardSuccess) {
      this.props.getOnboardStatus()
    }
  }

  render() {
    const {steps, isLoadedStep, isInited, isOnboardSuccess} = this.props

    if (!isInited || !isLoadedStep || isOnboardSuccess) {
      return null
    }

    const step = _.find(steps, {step: this.props.currentStep})
    const isCompleted = step.status === 'completed'

    return (
      <div className='onboarding-container'>
        <div className='steps-list'>
          <div className={`step-item ${isCompleted ? 'confirmed' : ''}`}>
            {isCompleted ? (
              <div className='step-marker'>
                <span className='checkmark'>✓</span>
              </div>
            ) : null}

            <div className='step-content'>
              <h4 className='step-title'>{step.title}</h4>
              <p className='step-description'>{step.description}</p>
            </div>
            {!isCompleted && (
              <Button
                className='confirm-button'
                onClick={() => this.onConfirm(step)}
              >
                Confirm
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  onConfirm(step) {
    this.props.confirmStep(step.step)
  }
}

const mapStateToProps = state => {
  return {
    steps: state.onboard.steps,
    isInited: state.onboard.isInited,
    isOnboardSuccess: state.onboard.isOnboardSuccess,
    isLoadedStep: state.onboard.isLoadedStep,
    currentSite: getCurrentSite(state)
  }
}

export default connect(mapStateToProps, {
  getOnboardStatus,
  confirmStep,
  initState
})(OnboardingWizard)



// WEBPACK FOOTER //
// ./client/components/OnboardingWizard/index.js